import Hls from 'hls.js';

/**
 * Creates a custom hls.js playlist loader class that propagates CDN auth query
 * params to all playlist requests and optionally strips LL-HLS blocking delivery
 * params (_HLS_msn, _HLS_part) for standard HLS engines.
 */
export function createPlaylistLoaderClass(queryParams: string | (() => string), isLowLatency: boolean) {
  const ParentLoader = Hls.DefaultConfig.loader;

  // Inherit the full loader contract, including context, stats and cache age.
  // hls.js uses context to preserve pending blocking playlist requests.
  return class PlaylistLoader extends ParentLoader {
    load(context: any, config: any, callbacks: any) {
      if (!isLowLatency) {
        try {
          const u = new URL(context.url);
          u.searchParams.delete('_HLS_msn');
          u.searchParams.delete('_HLS_part');
          context.url = u.toString();
        } catch { /* leave as-is if URL cannot be parsed */ }
      }
      const params = typeof queryParams === 'function' ? queryParams() : queryParams;
      if (params) {
        try {
          const url = new URL(context.url);
          // Replace old signed parameters, including those embedded in rendition URLs.
          new URLSearchParams(params).forEach((value, key) => url.searchParams.set(key, value));
          context.url = url.href;
        } catch {
          context.url += (context.url.includes('?') ? '&' : '?') + params;
        }
      }
      super.load(context, config, callbacks);
    }
  };
}
